var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.19 2H7.82C4.17 2 2 4.17 2 7.81V16.18C2 19.82 4.17 21.99 7.81 21.99H16.18C19.82 21.99 21.99 19.82 21.99 16.18V7.81C22 4.17 19.83 2 16.19 2Z",
    fill: "#EBF3FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4714 15.0398C11.5414 15.1098 11.6214 15.1598 11.7114 15.1998C11.8014 15.2398 11.9014 15.2598 12.0014 15.2598C12.1014 15.2598 12.1914 15.2398 12.2914 15.1998C12.3814 15.1598 12.4614 15.1098 12.5314 15.0398L15.5314 12.0398C15.8214 11.7498 15.8214 11.2698 15.5314 10.9798C15.2414 10.6898 14.7614 10.6898 14.4714 10.9798L12.7514 12.6998V6.50977C12.7514 6.09977 12.4114 5.75977 12.0014 5.75977C11.5914 5.75977 11.2514 6.09977 11.2514 6.50977V12.6998L9.5314 10.9798C9.2414 10.6898 8.76141 10.6898 8.47141 10.9798C8.18141 11.2698 8.18141 11.7498 8.47141 12.0398L11.4714 15.0398Z",
    fill: "#117FD6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7107 16.28C18.5807 15.89 18.1607 15.68 17.7607 15.81C14.0407 17.05 9.95067 17.05 6.23067 15.81C5.84067 15.68 5.41067 15.89 5.28067 16.28C5.15067 16.67 5.36067 17.1 5.75067 17.23C7.76067 17.9 9.87067 18.24 11.9907 18.24C14.1107 18.24 16.2207 17.9 18.2307 17.23C18.6307 17.09 18.8407 16.67 18.7107 16.28Z",
    fill: "#117FD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.1a1de1b48273e2523804849c6f70aac3.svg";
export { ForwardRef as ReactComponent };